import { createSpacing, Spacing } from '@mui/system';

export default createSpacing(8) as Spacing;
